import { useDispatch, useSelector } from "react-redux";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { State } from "./State";
import { useEffect } from "react";
import { Toaster } from "@/components/ui/sonner"
import { toast } from 'sonner'
import { INotificationPayloadData } from "./sagas/notificationsReducer";
import { DialogHelper } from "./DialogHelper";

const Container = ({ children }: { children: any }) => {
    const _notifications = useSelector((state: any) => state.notifications.notifications);
    const dispatch = useDispatch();

    useEffect(() => {
        _notifications.forEach((n: INotificationPayloadData) => {
            switch (n.variant) {
                case 'default':
                    toast.message(n.title, { description: n.description, });
                    break;
                case 'success':
                    toast.success(n.title, { description: n.description, });
                    break;
                case 'error':
                    toast.error(n.title, { description: n.description, });
                    break;
                case 'info':
                    toast.info(n.title, { description: n.description, });
                    break;
                case 'warning':
                    toast.warning(n.title, { description: n.description, });
                    break;
                default:
                    toast.message(n.title, { description: n.description, });
                    break;

            }
            dispatch({ type: 'REMOVE_NOTIFICATION', payload: n.id });
        })
    }, [_notifications, dispatch])

    return (
        <>
            <State />
            <div className="flex min-h-screen w-full flex-col bg-canvas text-ink">
                <Header />
                {/* Clears the fixed chrome (bar height + identity strip). */}
                <main className="flex w-full flex-grow flex-col pt-[calc(var(--nz-header-h)+3px)]">
                    {children}
                </main>
                <Footer />
            </div>
            <Toaster />
            <DialogHelper />
        </>
    )
}

export default Container;
